import './index.scss'

const targetBlocks = [
  'core/list',
  'core/categories',
  'aver/get-terms-block',
  'aver/relatedpost-block',
  'aver/relatedevent-block',
];

const styles = [
  { name: 'aver-list-menu', label: 'List Menu' },
  { name: 'aver-highlighted-list', label: 'Highlighted List' },
  { name: 'aver-checkmark-list', label: 'Checkmark List' },
  { name: 'aver-tag-style', label: 'Tag Style' },
  { name: 'aver-disc-list', label: 'Disc List' },
  { name: 'aver-list-none', label: 'List None' },
];

styles.forEach((style) => {
  targetBlocks.forEach((block) => {
    wp.blocks.registerBlockStyle(block, style);
  });
});


